<template>
  <div class="container-fluid">
    <breadcrumbs></breadcrumbs>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <router-link
              tag="button"
              class="btn btn-info float-right"
              :to="{ name: 'NewCompany' }"
            >
              Create Company
            </router-link>
            <h3 class="card-title pb-3">Companies</h3>
            <DataTable
              :columns="headers"
              fieldName="companies"
              :query="companies"
              placeholder="Search by Company name"
            >
              <span slot="companyName" slot-scope="props">
                <router-link :to="{ name: 'EditCompany', params: { id: props.row.id } }">
                  {{ props.row.companyName }}
                </router-link>
              </span>
              <span slot="description" slot-scope="props" class="truncate">
                {{ props.row.description }}
              </span>
              <span slot="created" slot-scope="props">
                {{ props.row.created | moment("MMM Do YYYY") }}
              </span>
              <span slot="status" slot-scope="props">
                {{ props.row.status ? 'Active' : 'Inactive' }}
              </span>
              <span slot="overdue" slot-scope="props">
                {{ props.row.overdue ? 'Yes' : '' }}
              </span>
              <span slot="overdueSince" slot-scope="props">
                {{ props.row.overdueSince | moment("MMM Do YYYY") }}
              </span>
              <span slot="actions" slot-scope="props">
                <router-link :to="{ name: 'EditCompany', params: { id: props.row.id } }">
                  <i class="mdi mdi-pencil text-inverse m-r-10"></i>
                </router-link>
                <a href="#">
                  <i class="mdi mdi-checkbox-marked-outline text-inverse"></i>
                </a>
              </span>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable';
import COMPANIES from '../../graphql/Companies/Companies.gql';

export default {
  name: 'Companies',
  components: {
    DataTable,
  },
  data() {
    return {
      companies: COMPANIES,
      headers: [
        { field: 'id', title: 'Id' },
        { title: 'Company Name', field: 'companyName' },
        { title: 'Description', field: 'description' },
        { title: 'Status', field: 'status' },
        { title: 'Created', field: 'created' },
        { title: 'Overdue', field: 'overdue' },
        { title: 'Overdue Since', field: 'overdueSince' },
        { title: 'Actions', field: 'actions', skipSorting: true },
      ],
    };
  },
};
</script>

<style scoped>
.truncate {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/Companies/Companies.vue